import * as React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core";
import {forwardRef} from "react";

export const CloseCompact: React.FC<SvgIconProps> = forwardRef(
  ({...props}, ref) => {
    return (
      <SvgIcon {...props} viewBox="0 0 20 20" innerRef={ref}>
        <g transform="translate(-519 -1033)">
          <g transform="translate(519 1033)">
            <path d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" fill="#fff" />
            <g data-name="Крестик серый 10" transform="translate(-1.895 8.587)">
              <path
                d="M-223.743,14183.19l-2.12-2.119-2.12,2.119a1,1,0,0,1-1.417,0,1,1,0,0,1,0-1.413l2.122-2.121-2.122-2.122a1,1,0,0,1,0-1.413,1,1,0,0,1,1.417,0l2.12,2.12,2.12-2.12a1,1,0,0,1,1.417,0,1,1,0,0,1,0,1.413l-2.122,2.122,2.122,2.121a1,1,0,0,1,0,1.413,1,1,0,0,1-.708.294A1,1,0,0,1-223.743,14183.19Z"
                transform="translate(237.757 -14178.242)"
                fill="#6d6d6d"
              />
            </g>
          </g>
          <rect
            width="20"
            height="20"
            transform="translate(519 1033)"
            fill="none"
          />
        </g>
      </SvgIcon>
    );
  }
);

export default CloseCompact;
